
import { Vue, Component } from 'vue-property-decorator';
import { getRule, getBaseInfo, getVoteList } from '../api';
import SearchBar from '../components/SearchBar.vue';
import VoteButton from '../components/VoteButtonNew.vue';
import { List, Lazyload, Dialog, Toast, CountDown } from 'vant';
Vue.use(List)
  .use(Lazyload)
  .use(Dialog)
  .use(Toast)
  .use(CountDown);

@Component({
  components: {
    SearchBar,
    VoteButton
  },
})
export default class Home extends Vue {
  rules :any = '';
  baseInfo : any = [];
  other: any = [];
  downTime: any = new Date('2025-01-26T18:00:00').getTime() - Date.now();
  search = '';
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  show: boolean = true;
  showSearch: boolean = true;
  workType = 1;
  async created() {
    // const other = await getOther();
    // this.other = other.data;
    const ret = await getRule();
    this.rules = ret.data;
    const base = await getBaseInfo();
    this.baseInfo = base.data;
    const endTime = base.data.endTime;
    this.downTime = new Date(parseInt(endTime) * 1000).getTime() - Date.now();
  }

  tens(number: any) {
    const tens = Math.floor(number / 10); // 十位数
    return tens;
  }
  units(number: any) {
    const units = number % 10; // 个位数
    return units;
  }
  async onLoad() {
    getVoteList(this.page, this.search).then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (res.data.length === 0 || res.data.length === 0) {
      this.finished = true;
    } else {
      this.list = [...this.list, ...res.data];
    }
    this.loading = false;
  }
  onSearch() {
    this.finished = false;
    this.page = 1;
    this.list = [];
    this.show = false;
    setTimeout(() => {
      this.show = true;
    }, 50);
  }
  clear() {
    this.list = [];
    this.page = 1;
    this.finished = false;
    this.workType = 1;
  }
  userInputChange(text: string) {
    this.search = text;
  }
  change(num: any){
    this.clear();
    this.search = '';
    this.workType = num;
    this.show = false;
    this.showSearch = false;
    setTimeout(() => {
      this.showSearch = true;
      this.show = true;
    }, 50);
  }
  goDetail(id: any) {
    this.$router.push(`detail?id=${id}`);
  }
  onVoteSuccess(data: string, index:number) {
    this.list[index].votes = data;
  }
}
